import { LiveData, Service } from '@toeverything/infra';
import { combineLatest, map } from 'rxjs';

import type { WorkspaceFlavoursProvider } from '../providers/flavour';

export class WorkspaceFlavoursService extends Service {
  constructor(private readonly providers: WorkspaceFlavoursProvider[]) {
    super();
    console.log('[WorkspaceFlavoursService] constructor, providers count:', providers.length);
  }

  flavours$ = LiveData.from(
    combineLatest(this.providers.map(p => p.workspaceFlavours$)).pipe(
      map(flavours => {
        const flat = flavours.flat();
        console.log('[WorkspaceFlavoursService] flavours$ emit, flavour counts per provider:', flavours.map(f => f.length), 'total:', flat.length);
        return flat;
      })
    ),
    []
  );
}
